import { DialogActions, Dialog, DialogContent, DialogContentText, IconButton, Tooltip, Button,} from "@material-ui/core";
import ExitIcon from "@material-ui/icons/PowerSettingsNew";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import UseAnalyticsEvent from "../utils/useAnalyticsEvent";
import { useState } from "react";
import {
	MenuItemLink,
} from "react-admin";

const LogoutDialog = ({ onLogout, menuExpanded }) => {
	const classes = useStyles();
	const eventTracker = UseAnalyticsEvent();
	const [logoutDialogVisible, setlogoutDialogVisible] = useState(false);
	const logouHandler = () => {
		onLogout();
		eventTracker(
			"SIDE NAVIGATION MENU",
			"LOGOUT",
			"User Logged out from dashboard"
		);
		const element = document.getElementById("kiwi-big-iframe-wrapper");
		if (element) {
			element.style.display = "block";
		}
	};
	return (
		<>
		{menuExpanded ? (
			<Tooltip title="Logout" placement="bottom-end">
				<MenuItemLink
					to="#"
					primaryText="Logout"
					leftIcon={<ExitIcon />}
					sidebarIsOpen={menuExpanded}
					className="RaMenuItemLink-default"
					onClick={() => setlogoutDialogVisible(true)}
				/>
			</Tooltip>
		) : (
			<IconButton onClick={() => setlogoutDialogVisible(true)}>
				<ExitIcon />
			</IconButton>
		)}
		<Dialog
			open={logoutDialogVisible}
			onClose={() => setlogoutDialogVisible(false)}
			fullWidth
			classes={{ paper: classes.dialogPaper }}
			BackdropProps={{
				classes: {
					root: classes.backDrop,
				},
			}}>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					Are you sure you want to <strong>Logout</strong>.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => setlogoutDialogVisible(false)}
					color="error"
					variant="contained"
					style={{
						textTransform: "none",
						fontSize: 13,
						fontFamily: "Poppins-Regular",
						letterSpacing: "0.06em",
						height: "40px",
						minWidth: "120px",
						backgroundColor: "#E7EBF0",
						color: "#334D6E",
					}}
					disableElevation>
					Cancel
				</Button>
				<Button
					onClick={logouHandler}
					color="contained"
					variant="contained"
					style={{
						backgroundColor: "#de575e",
						color: "#FFF",
						textTransform: "none",
						fontSize: 13,
						fontFamily: "Poppins-Regular",
						letterSpacing: "0.06em",
						height: "40px",
						minWidth: "120px",
					}}
					autoFocus
					disableElevation>
					Logout
				</Button>
			</DialogActions>
		</Dialog>
		</>
	);
};

export default LogoutDialog;


